import { z } from 'zod';
// [multi-market] Wire schemas for a brand's set of target markets.
// See spec multi-market-support-global-brands. The DB source of truth is
// the brand_markets table; brands.target_country/target_language mirror
// the primary market.
/** One market the founder is sending Mag into. language is optional on
 *  input — the server defaults it from the country (countryToDefaultLanguage). */
export const brandMarketInputSchema = z.object({
    country: z.string().length(2),
    language: z.string().min(2).max(8).optional(),
    isPrimary: z.boolean().optional(),
});
/** POST /api/brands/:id/markets body. At least one market; primary is the
 *  one flagged isPrimary, else the first. */
export const setBrandMarketsBodySchema = z.object({
    markets: z.array(brandMarketInputSchema).min(1).max(20),
});
/** Serialized market row returned to the dashboard. */
export const brandMarketSchema = z.object({
    country: z.string().length(2),
    language: z.string().min(2).max(8),
    isPrimary: z.boolean(),
    sortOrder: z.number().int(),
});
//# sourceMappingURL=brand-markets.js.map